import { useProfile } from './profile';

export function useFeatureFlag(flagName: string): boolean {
  const { data: profile } = useProfile();
  return profile?.featureFlags?.includes(flagName) ?? false;
}
